const campaignUrlParams = new URLSearchParams(window.location.search);
const hasCampaignUrlParams = campaignUrlParams.toString().length > 0;
const redirected = campaignUrlParams.get("redirected");
const utm_source = campaignUrlParams.get("utm_source");
const utm_campaign = campaignUrlParams.get("utm_campaign");

// Set coupon code cookie, if we're enabling an automatic coupon code
// eslint-disable-next-line no-undef
if (window.campaignCouponCode) {
  let domain_parts = window.location.hostname.split(".");
  document.cookie = `coupon_code=${
    window.campaignCouponCode
  }; domain=.discourse.${
    domain_parts[domain_parts.length - 1]
  }; path=/; max-age=${24 * 60 * 60}; SameSite=Strict; Secure`;
}

// Check if we've already done a redirect
if (!redirected && !utm_source && !utm_campaign) {
  // Redirect with the campaign params to track only if we didn't get them
  // from the referring link.
  window.location.href =
    `${window.location.href}` +
    `${!hasCampaignUrlParams ? "?" : "&"}` +
    `redirected=true` +
    `&utm_source=${window.campaignSource}&s=${window.campaignSource}` +
    `&utm_campaign=${window.campaignCampaign}&c=${window.campaignCampaign}`;
}
